<template>
  <v-modal ref="modal" :target="target" v-bind="$attrs" :backdrop-styles="$options.backdropStyles">
    <div class="app-modal">
      <slot></slot>
    </div>
  </v-modal>
</template>

<script>
export default {
  name: 'AppModal',
  props: {
    target: {
      type: String,
      default: 'root-modal'
    }
  },
  backdropStyles: {
    backgroundColor: '#000000',
    opacity: '0.5'
  },
  methods: {
    open() {
      return this.$refs.modal.open();
    }
  }
};
</script>

<style lang="scss" scoped>
.app-modal {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  max-width: 100%;
}
</style>
